<template>
<div class="d-flex justify-content-center">
 <VueRssFeed :feedUrl="feedUrl" :name="name" :limit="limit"/>
 </div>
</template>

<script>
import VueRssFeed from "../RssFeed/VueRssFeed.vue";
export default {
  name: "Demo",
  components: {
    VueRssFeed
  },
  data() {
    return {
      feedUrl: "https://rss.app/feeds/06PDsmGBoV4err56.xml",
      name: "",
      limit: 5,
    };
  },
};
</script>

<style scoped>
</style>